import { useState, useEffect } from "react";
import Board from "./Board";
import styled, { createGlobalStyle, ThemeProvider } from "styled-components";
import gradient from "../images/gradient.png";
import hardcore from "../images/hardcore.jpg";
import background from "../images/bgPattern.png";

const GlobalStyle = createGlobalStyle`
body {
  width: 100vw;
  height: 100vh;
}

#root {
  width: 100%;
  height: 100%;
  display: flex;
}
`;

const ClassicTheme = {
  gradient: `url(${gradient})`,
  tileColor: "#0c3939",
  openColor: "rgb(221, 219, 96)",
  modeButton: "20px solid rgba(24, 138, 141, 1)",
  buttonColor: "rgba(24, 138, 141, 1)",
  tileShadow: "1px 1px 5px 1px rgb(117, 117, 117)",
  fontColor: "rgb(105, 151, 153)",
  gap: "2em",
  titleMargin: "0em",
};

const HardcoreTheme = {
  gradient: `url(${hardcore})`,
  tileColor: "#610f28",
  openColor: "rgb(96, 181, 221)",
  modeButton: "20px solid #F7492B",
  buttonColor: "#F7492B",
  tileShadow: "1px 1px 3px 1px rgb(61, 61, 61);",
  fontColor: "rgb(153, 105, 131)",
  gap: "1.3em",
  titleMargin: ".7em",
};

const MainApp = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2em;
  background-image: url(${background});
  gap: ${(props) => props.theme.gap};
`;

const Title = styled.div`
  display: flex;
  font-weight: 500;
  gap: 0em;
  white-space: pre;
  align-items: center;
  margin-bottom: ${(props) => props.theme.titleMargin};

  .modeDiv {
    display: flex;
    gap: 0.5em;
    align-items: center;
  }

  .mode {
    width: 0;
    height: 0;
    border: none;
    background-color: transparent;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: ${(props) => props.theme.modeButton};
    cursor: pointer;
  }

  .Classich1 {
    background-image: url(${gradient});
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
  }

  .Hardcoreh1 {
    background: url(${hardcore});
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
  }

  
  @media only screen and (max-width: 412px) {
      flex-direction: column;
  }

`;

const Nav = styled.div`
  display: flex;
  width: 80%;
  max-width: 700px;
  justify-content: space-between;
  height: 2.5em;
  align-items: center;
  font-weight: 500;
  color: ${(props) => props.theme.fontColor};
  font-size: 1.1rem;
  flex-wrap: wrap;
  gap: .5em;

  .restart {
    padding: 0.8em 1.2em;
    border: none;
    background-color: ${(props) => props.theme.buttonColor};
    color: white;
    font-weight: 500;
    border-radius: 5px;
  }
`;

const Result = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  h1 {
    background: ${(props) => props.theme.gradient};
    text-align: center;
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
    background-size: cover;
  }

  @media only screen and (max-width: 412px) {
      h1 {
        font-size: 1.3rem;
        margin-top: .5em;
      }
  }

`;

function App() {
  let [time, setTime] = useState(0);
  let [moves, setMoves] = useState(0);
  let [score, setScore] = useState(0);
  let [started, setStarted] = useState(false);
  let [pics, setPics] = useState([
    1,
    1,
    2,
    2,
    3,
    3,
    4,
    4,
    5,
    5,
    6,
    6,
    7,
    7,
    8,
    8,
  ]);
  let [tileOpened, settileOpened] = useState([]);
  let [state, setState] = useState(new Array(16).fill("hidden"));
  let [result, setResult] = useState(false);
  let [lost, setLost] = useState(false);

  useEffect(() => {
    let timer;
    if (started) {
      if (mode === "Classic")
        timer = setInterval(() => setTime((p) => p + 1), 1000);
      else timer = setInterval(() => setTime((p) => p - 1), 1000);
    }
    return () => clearInterval(timer);
    // eslint-disable-next-line
  }, [started]);

  useEffect(
    () => restart(),
    // eslint-disable-next-line
    []
  );

  useEffect(() => {
    if (score === 8) {
      setStarted(false);
      setResult(true);
    }
    if (mode === "Hardcore" && time === 0) {
      setStarted(false);
      setResult(true);
      setLost(true);
    }
    // eslint-disable-next-line
  }, [score, time]);

  function clicked(svgNo, i) {
    if (state[i] === "matched") return;
    if (tileOpened.length === 0) {
      updateNav(false);
      openTile(svgNo, i);
    } else if (tileOpened.length === 2 && tileOpened[1] !== i) {
      openTile(svgNo, i);
      if (tileOpened[0] === svgNo) {
        updateNav(true);
        if (mode === 'Classic') setTimeout(() => nextMove("matched", i), 500);
        else setTimeout(() => nextMove("matched", i), 300);
      } else {
        updateNav(false);
        if (mode === 'Classic') setTimeout(() => nextMove("hidden", i), 500);
        else setTimeout(() => nextMove("hidden", i), 300);
      }
    }
  }

  function openTile(svgNo, i) {
    settileOpened([...tileOpened, svgNo, i]);
    let copy = state.slice();
    copy[i] = "opened";
    setState(copy);
  }

  function nextMove(stat, i) {
    let copy = state.slice();
    copy[tileOpened[1]] = stat;
    copy[i] = stat;
    setState(copy);
    settileOpened([]);
  }

  function updateNav(match) {
    if (!started) setStarted(true);
    else {
      setMoves((p) => p + 1);
      if (match) setScore((p) => p + 1);
    }
  }

  function restart() {
    if (mode === "Classic") setTime(0);
    else setTime(20);
    let copy = pics.slice();
    copy.sort((a, b) => 0.5 - Math.random());
    setPics(copy);
    setScore(0);
    setMoves(0);
    setStarted(false);
    setState(new Array(16).fill("hidden"));
    settileOpened([]);
    setResult(false);
    setLost(false);
  }

  let [mode, setMode] = useState("Classic");
  let [theme, setTheme] = useState(ClassicTheme);

  function changeMode() {
    restart();
    if (mode === "Classic") {
      setMode("Hardcore");
      setTheme(HardcoreTheme);
      setTime(20);
    } else {
      setMode("Classic");
      setTheme(ClassicTheme);
      setTime(0);
    }
  }

  return (
    <ThemeProvider theme={theme}>
      <GlobalStyle />
      <MainApp>
        <Title>
          <h1>
            Memory Game{" "}
          </h1>
          <div className="modeDiv">
            <h1 onClick={changeMode} className={mode + "h1"}>
              {mode}
            </h1>
          <button className="mode" onClick={changeMode}></button>
          </div>
        </Title>
        <Nav>
          <div className="timer">Time: {time}s</div>
          <div className="moves">{moves} moves</div>
          <div className="score">Score: {score}</div>
          <button className="restart" onClick={restart}>
            Restart
          </button>
        </Nav>
        {result && (
          <Result>
            {mode === "Classic" && (
              <h1>
                Congratulations! You won in {moves} moves! <br /> It took you{" "}
                {time} seconds.
              </h1>
            )}
            {mode === "Hardcore" && (
              <Result>
                {!lost && (
                  <h1>
                    Congratulations! You matched all pairs! <br /> You still
                    have {time === 1 ? '1 second' : time + ' seconds'} left.
                  </h1>
                )}
                {lost && (
                  <h1>
                    Time's Up! <br />{" "}
                    {score === 0
                      ? "You didn't manage to match any pair"
                      : score === 1
                      ? "You only managed to match 1 pair"
                      : "You only managed to match " + score + " pairs"}{" "}
                    :(
                  </h1>
                )}
              </Result>
            )}
          </Result>
        )}
        {mode === "Hardcore" && !result && (
          <Result sub>
            <h1>Matched all pairs within 20 seconds</h1>
          </Result>
        )}
        {!result && <Board pics={pics} clicked={clicked} state={state} />}
      </MainApp>
    </ThemeProvider>
  );
}

export default App;
